import * as React from 'react';
import styled from '@emotion/styled';

const Blurred = styled.span`
  display: inline-block;
  filter: blur(8px);
  user-select: none;
`;

export function Blur({ children }: { children: React.ReactNode }): JSX.Element {
  return <Blurred aria-hidden>{children}</Blurred>;
}
